import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import AnotherSeller from 'components-v2/mocules/AnotherSeller';
import CardImage from 'components-v2/mocules/CardImage';
import HotInfo from 'components-v2/mocules/HotInfo';
import PromoType from 'components-v2/mocules/PromoType';
import QuantityControl from 'components-v2/mocules/QuantityControl';
import FlagshipLabel from 'components-v2/mocules/FlagshipLabel';
import TagGiftComp from 'components-v2/mocules/TagGiftComp';
import TagComponent from 'components/mocules/TagComponent';
import { SVGPrice } from 'constants/SVG';
import useCartQuantity from 'zustand-lib/useCartQuantity';
import styles from './styles.module.css';

const ModalViewMore = ({
  product,
  imagesProxy,
  messageLimitOrder,
  openModal,
  closeModal,
  productType,
  monthYear,
  name,
  volume,
  displayPriceFormated,
  salePriceFormated,
  discountPercent,
  productsSame,
  sellerInfo,
  campaign,
  deal,
}) => {
  const { score } = useCartQuantity((state) => state);

  if (!openModal) return null;

  return (
    <Modal open={openModal} onClose={closeModal}>
      <div className={clsx(styles.modalContainer, openModal && styles.show)}>
        <ButtonBase onClick={() => closeModal()} className={styles?.buttonModal}>
          <CloseIcon /> Đóng
        </ButtonBase>
        <Grid container spacing={2} className={styles.modalWrapper}>
          <Grid item xs={4}>
            <CardImage img={imagesProxy[0]} hiddenIconAndText hasModal />
          </Grid>
          <Grid item xs={8} className={styles.rightContent}>
            {productType !== 'NORMAL' ? (
              <HotInfo
                title={<PromoType productType={campaign?.campaign} monthYear={monthYear} />}
                productType={productType}
                campaign={campaign}
                deal={deal}
              />
            ) : null}
            <div>
              <Typography className={styles.typographyTitle}>
                <FlagshipLabel isVip={sellerInfo?.isVip} isStore={sellerInfo?.isStore} productTags={product?.tags} />
                {product?.isTagGift && <TagGiftComp />} {name || ''}
                {name || ''}
              </Typography>
              <Typography className={styles.typographyRight}> {volume || ''}</Typography>
            </div>
            <div className={styles.rowPrice}>
              <div className={styles.priceInfo}>
                <Typography className={styles.price}>{<SVGPrice displayPriceFormated={displayPriceFormated} fillPath="#0C884E" /> || 0}</Typography>
                {discountPercent ? (
                  <div style={{ display: 'flex', gap: 10 }}>
                    <span className={styles.originalPrice}>
                      <SVGPrice displayPriceFormated={salePriceFormated || 0} size="sm" fillPath="#8D8D8D" line />
                    </span>
                    <span className={styles.discountPercent}> -{discountPercent}%</span>
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.hightLightTag}>
              <TagComponent
                product={{ tags: product.tags, statusData: product.statusData, expiredDate: product.expiredDate }}
                isProductCard={false}
                isSellerList={false}
                isPageDetail
                isLinkTagDeal
              />
            </div>
            <div className={styles.quantityModal}>
              <div className={styles.canBuyAndScore}>
                <Typography className={styles.typography}> {messageLimitOrder || ''}</Typography>
                <Typography className={styles.score}> {score !== '0' ? `${score} điểm` : ''} </Typography>
              </div>
              <QuantityControl product={product} />
            </div>
          </Grid>
          {productsSame?.length > 0 ? (
            <>
              <Grid item xs={12}>
                <Typography className={styles.sameSeller}> {productsSame?.length} nhà bán hàng cùng sản phẩm</Typography>
              </Grid>
              <Grid item xs={12}>
                <AnotherSeller products={productsSame} productCompare={product} isModal />
              </Grid>
            </>
          ) : null}
        </Grid>
      </div>
    </Modal>
  );
};
export default ModalViewMore;

